// extracted by mini-css-extract-plugin
export default {"switcher":"gdCcAEsJgjzs3GKaFhPW","current":"YtHX9ohVG4pHmG2348s5","select":"xT0a6zevjw3RohLkaASJ"};